import { Axios } from "./request";

const API_URL = "usersapi/v1/profiles/";

export const PROFILES_API = {
  GetMyCurrentState: () => {
    return Axios.get(`${API_URL}GetMyCurrentState`);
  },
  AssignBranchToProfile: (branchId) => {
    return Axios.post(`${API_URL}AssignBranchToProfile?branchId=${branchId}`);
  },
  SendProfileForApproval: () => {
    return Axios.post(`${API_URL}SendProfileForApproval`);
  },
  ChooseSearchByType: (isByBranch) => {
    return Axios.post(`${API_URL}ChooseSearchByType?isByBranch=${isByBranch}`);
  },
  SendCandidatesForApproval: () => {
    return Axios.post(`${API_URL}SendCandidatesForApproval`);
  },
  ApproveEditedProfileFromInterviewer: () => {
    return Axios.post(`${API_URL}ApproveEditedProfileFromInterviewer`);
  },
  RejectEditedProfileFromInterviewer: () => {
    return Axios.post(`${API_URL}RejectEditedProfileFromInterviewer`);
  },
  GetIsCandidate: (profileNumber) => {
    return Axios.get(`${API_URL}IsCandidate?profileNumber=${profileNumber}`);
  },
  RequestProfileEdit: () => {
    return Axios.post(`${API_URL}RequestProfileEdit`);
  },
  RequestProfileDeactive: () => {
    return Axios.post(`${API_URL}RequestProfileDeactive`);
  },
  ContinuationRequestProfileDefined: () => {
    return Axios.post(`${API_URL}ContinuationRequestProfileDefined`);
  },
};
